document.addEventListener('DOMContentLoaded', function() {

    const allInputs = document.querySelectorAll('.custom-filter-wrapper input');
    const selectElements = document.querySelectorAll('.custom-filter-wrapper select');

    // Handle lifestage filter active states
    function updateLifestageActiveStates() {
        const lifestageCheckboxes = document.querySelectorAll('.lifestage-filter-input');
        lifestageCheckboxes.forEach(checkbox => {
            const lifestageItem = checkbox.closest('.lifestage-items');
            if (lifestageItem) {
                if (checkbox.checked) {
                    lifestageItem.classList.add('active');
                } else {
                    lifestageItem.classList.remove('active');
                }
            }
        });
    }

    // Initialize active states on page load
    updateLifestageActiveStates();

    // Listen for checkbox changes to update active states
    const lifestageCheckboxes = document.querySelectorAll('.lifestage-filter-input');
    lifestageCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            updateLifestageActiveStates();
            updateSelectedFilters();

            if (typeof updateCollectionResults === 'function') {
                updateCollectionResults();
            }
        });
    });

    // Handle product-type filter active states
    function updateProductTypeActiveStates() {
        const productTypeCheckboxes = document.querySelectorAll('.product-type-filter-input');
        productTypeCheckboxes.forEach(checkbox => {
            const productTypeItem = checkbox.closest('.product-type-items');
            if (productTypeItem) {
                if (checkbox.checked) {
                    productTypeItem.classList.add('active');
                } else {
                    productTypeItem.classList.remove('active');
                }
            }
        });
    }

    // Initialize product-type active states on page load
    updateProductTypeActiveStates();

    // Listen for product-type checkbox changes
    const productTypeCheckboxes = document.querySelectorAll('.product-type-filter-input');
    productTypeCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            updateProductTypeActiveStates();
            updateSelectedFilters();

            // If there's an updateCollectionResults function (AJAX), call it
            if (typeof updateCollectionResults === 'function') {
                updateCollectionResults();
            }
        });
    });

    // Listen for all other filter changes
    const allFilterInputs = document.querySelectorAll('.custom-filter input[type="checkbox"]');
    allFilterInputs.forEach(input => {
        input.addEventListener('change', function() {
            updateSelectedFilters();

            // If there's an updateCollectionResults function (AJAX), call it
            if (typeof updateCollectionResults === 'function') {
                updateCollectionResults();
            }
        });
    });

    // Handle price range filter functionality
    function initializePriceRangeFilters() {
        const rangeMin = document.querySelector('.range-min');
        const rangeMax = document.querySelector('.range-max');
        const minPriceFilter = document.querySelector('.min-price-filter');
        const maxPriceFilter = document.querySelector('.max-price-filter');
        const inputMin = document.querySelector('.input-min');
        const inputMax = document.querySelector('.input-max');
        const progress = document.querySelector('.progress');

        if (!rangeMin || !rangeMax || !minPriceFilter || !maxPriceFilter) {
            console.log('Price range elements not found');
            return;
        }


        let updateTimeout; // For debouncing updates

        // Update visual display and hidden inputs
        function updatePriceDisplay() {
            const minVal = parseInt(rangeMin.value);
            const maxVal = parseInt(rangeMax.value);
            const maxRange = parseInt(rangeMin.max);

            // Ensure min doesn't exceed max
            if (minVal >= maxVal - 10) {
                rangeMin.value = maxVal - 10;
            }
            if (maxVal <= minVal + 10) {
                rangeMax.value = minVal + 10;
            }

            const finalMinVal = parseInt(rangeMin.value);
            const finalMaxVal = parseInt(rangeMax.value);

            // Update visual display
            if (inputMin) inputMin.textContent = finalMinVal;
            if (inputMax) inputMax.textContent = finalMaxVal;

            // Update hidden form inputs
            minPriceFilter.value = finalMinVal;
            maxPriceFilter.value = finalMaxVal;

            // Update progress bar
            if (progress) {
                const leftPercent = (finalMinVal / maxRange) * 100;
                const rightPercent = 100 - (finalMaxVal / maxRange) * 100;
                progress.style.left = leftPercent + '%';
                progress.style.right = rightPercent + '%';
            }

            // Update selected filters display
            updateSelectedFilters();

            // Clear existing timeout
            if (updateTimeout) {
                clearTimeout(updateTimeout);
            }

            // Trigger collection update with debouncing
            updateTimeout = setTimeout(() => {
                if (typeof updateCollectionResults === 'function') {
                    updateCollectionResults();
                } else {
                    console.warn('updateCollectionResults function not available, falling back to form submission');
                    // If AJAX isn't available, we could trigger a form submission as fallback
                    // But for now, just log the issue
                }
            }, 500); // Increased delay for better debouncing
        }

        // Handle slider input events (real-time updates)
        function handleSliderInput() {
            updatePriceDisplay();
        }

        // Handle slider change events (when user releases slider)
        function handleSliderChange() {
            updatePriceDisplay();
        }

        // Listen for range slider changes - both input (real-time) and change (on release)
        rangeMin.addEventListener('input', handleSliderInput);
        rangeMin.addEventListener('change', handleSliderChange);
        rangeMax.addEventListener('input', handleSliderInput);
        rangeMax.addEventListener('change', handleSliderChange);

        // Listen for direct input changes
        minPriceFilter.addEventListener('change', function() {
            const newValue = parseInt(this.value) || 0;
            rangeMin.value = newValue;
            updatePriceDisplay();
        });

        maxPriceFilter.addEventListener('change', function() {
            const newValue = parseInt(this.value) || parseInt(rangeMax.max);
            rangeMax.value = newValue;
            updatePriceDisplay();
        });

        // Initialize display on page load (but don't trigger AJAX on initial load)
        const minVal = parseInt(rangeMin.value);
        const maxVal = parseInt(rangeMax.value);
        const maxRange = parseInt(rangeMin.max);

        // Update visual display
        if (inputMin) inputMin.textContent = minVal;
        if (inputMax) inputMax.textContent = maxVal;

        // Update hidden form inputs
        minPriceFilter.value = minVal;
        maxPriceFilter.value = maxVal;

        // Update progress bar
        if (progress) {
            const leftPercent = (minVal / maxRange) * 100;
            const rightPercent = 100 - (maxVal / maxRange) * 100;
            progress.style.left = leftPercent + '%';
            progress.style.right = rightPercent + '%';
        }
    }

    // Utility: get query param from URL
    function getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Custom: set price filter from URL if present
    function setPriceFilterFromUrl() {
        const minPriceFilter = document.querySelector('.min-price-filter');
        const maxPriceFilter = document.querySelector('.max-price-filter');
        const rangeMin = document.querySelector('.range-min');
        const rangeMax = document.querySelector('.range-max');
        const inputMin = document.querySelector('.input-min');
        const inputMax = document.querySelector('.input-max');
        const progress = document.querySelector('.progress');
        if (!minPriceFilter || !maxPriceFilter || !rangeMin || !rangeMax) return;

        // Get param names from input fields
        const minParam = minPriceFilter.name;
        const maxParam = maxPriceFilter.name;
        // Fallback to standard Shopify param names if not present
        const minQuery = minParam || 'filter.v.price.gte';
        const maxQuery = maxParam || 'filter.v.price.lte';

        // Get values from URL
        const minVal = parseInt(getQueryParam(minQuery));
        const maxVal = parseInt(getQueryParam(maxQuery));
        let didSet = false;
        if (!isNaN(minVal)) {
            minPriceFilter.value = minVal;
            rangeMin.value = minVal;
            if (inputMin) inputMin.textContent = minVal;
            didSet = true;
        }
        if (!isNaN(maxVal)) {
            maxPriceFilter.value = maxVal;
            rangeMax.value = maxVal;
            if (inputMax) inputMax.textContent = maxVal;
            didSet = true;
        }
        // Update progress bar
        if (didSet && progress && rangeMin.max) {
            const leftPercent = (parseInt(rangeMin.value) / parseInt(rangeMin.max)) * 100;
            const rightPercent = 100 - (parseInt(rangeMax.value) / parseInt(rangeMin.max)) * 100;
            progress.style.left = leftPercent + '%';
            progress.style.right = rightPercent + '%';
        }
    }

    // Initialize price range filters
    initializePriceRangeFilters();
    // Set price filter from URL on page load
    setPriceFilterFromUrl();

    // Function to update selected filter tags dynamically
    function updateSelectedFilters() {
        // Custom: check for price filter in URL and show tag if present
        const minPriceFilterEl = document.querySelector('.min-price-filter');
        const maxPriceFilterEl = document.querySelector('.max-price-filter');
        const selectedFiltersContainerEl = document.getElementById('selected-filters-container');
        if (minPriceFilterEl && maxPriceFilterEl && selectedFiltersContainerEl) {
            const minParam = minPriceFilterEl.name || 'filter.v.price.gte';
            const maxParam = maxPriceFilterEl.name || 'filter.v.price.lte';
            const minValUrl = getQueryParam(minParam);
            const maxValUrl = getQueryParam(maxParam);
            if (minValUrl !== null || maxValUrl !== null) {
                // Remove existing price range filter tag
                const existingPriceTag = selectedFiltersContainerEl.querySelector('[data-filter-type="price_range"]');
                if (existingPriceTag && existingPriceTag.classList.contains('dynamic')) {
                    existingPriceTag.remove();
                }
                // Create new price range filter tag
                const priceFilterTag = document.createElement('a');
                priceFilterTag.className = 'selected-filter dynamic';
                priceFilterTag.setAttribute('href', '#');
                priceFilterTag.setAttribute('aria-label', 'Remove Price Filter');
                priceFilterTag.setAttribute('data-filter-type', 'price_range');
                priceFilterTag.setAttribute('data-min-param', minParam);
                priceFilterTag.setAttribute('data-max-param', maxParam);
                priceFilterTag.innerHTML = `
                    <svg width="10" height="10" viewBox="0 0 10 10">
                        <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    £${minValUrl || minPriceFilterEl.value} - £${maxValUrl || maxPriceFilterEl.value}
                `;
                priceFilterTag.addEventListener('click', function(e) {
                    e.preventDefault();
                    // Reset price inputs and sliders
                    const rangeMinEl = document.querySelector('.range-min');
                    const rangeMaxInputEl = document.querySelector('.range-max');
                    if (rangeMinEl && rangeMaxInputEl) {
                        rangeMinEl.value = 0;
                        rangeMaxInputEl.value = rangeMaxInputEl.max;
                        minPriceFilterEl.value = 0;
                        maxPriceFilterEl.value = rangeMaxInputEl.max;
                        const inputMinEl = document.querySelector('.input-min');
                        const inputMaxEl = document.querySelector('.input-max');
                        const progressEl = document.querySelector('.progress');
                        if (inputMinEl) inputMinEl.textContent = 0;
                        if (inputMaxEl) inputMaxEl.textContent = rangeMaxInputEl.max;
                        if (progressEl) {
                            progressEl.style.left = '0%';
                            progressEl.style.right = '0%';
                        }
                        updateSelectedFilters();
                        setTimeout(() => {
                            if (typeof updateCollectionResults === 'function') {
                                updateCollectionResults();
                            }
                        }, 50);
                    }
                });
                selectedFiltersContainerEl.appendChild(priceFilterTag);
            }
        }
        const selectedFiltersContainer = document.getElementById('selected-filters-container');
        if (!selectedFiltersContainer) return;

        // Clear existing dynamic filters (keep server-rendered ones for fallback)
        const existingDynamicFilters = selectedFiltersContainer.querySelectorAll('.selected-filter.dynamic');
        existingDynamicFilters.forEach(filter => filter.remove());

        // Handle price range filter tags
        const minPriceFilter = document.querySelector('.min-price-filter');
        const maxPriceFilter = document.querySelector('.max-price-filter');

        if (minPriceFilter && maxPriceFilter) {
            // Use the value attributes set by Liquid/server on page load
            const minValue = parseInt(minPriceFilter.value) || 0;
            const maxValue = parseInt(maxPriceFilter.value) || 0;
            const rangeMax = parseInt(maxPriceFilter.getAttribute('max')) || 0;
            const minDefault = 0;
            const maxDefault = rangeMax;

            // Show price range filter tag if values are different from defaults and not both zero
            if ((minValue > minDefault || maxValue < maxDefault) && !(minValue === minDefault && maxValue === minDefault)) {
                // Remove existing price range filter tag
                const existingPriceTag = selectedFiltersContainer.querySelector('[data-filter-type="price_range"]');
                if (existingPriceTag && existingPriceTag.classList.contains('dynamic')) {
                    existingPriceTag.remove();
                }

                // Create new price range filter tag
                const priceFilterTag = document.createElement('a');
                priceFilterTag.className = 'selected-filter dynamic';
                priceFilterTag.setAttribute('href', '#');
                priceFilterTag.setAttribute('aria-label', 'Remove Price Filter');
                priceFilterTag.setAttribute('data-filter-type', 'price_range');
                priceFilterTag.setAttribute('data-min-param', minPriceFilter.name);
                priceFilterTag.setAttribute('data-max-param', maxPriceFilter.name);

                priceFilterTag.innerHTML = `
                    <svg width="10" height="10" viewBox="0 0 10 10">
                        <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                    £${minValue} - £${maxValue}
                `;

                // Add click handler to reset price range
                priceFilterTag.addEventListener('click', function(e) {
                    e.preventDefault();

                    // Reset price inputs and sliders
                    const rangeMin = document.querySelector('.range-min');
                    const rangeMaxInput = document.querySelector('.range-max');

                    if (rangeMin && rangeMaxInput) {
                        rangeMin.value = minDefault;
                        rangeMaxInput.value = maxDefault;

                        // Clear form inputs
                        minPriceFilter.value = minDefault;
                        maxPriceFilter.value = maxDefault;

                        // Update visual display
                        const inputMin = document.querySelector('.input-min');
                        const inputMax = document.querySelector('.input-max');
                        const progress = document.querySelector('.progress');

                        if (inputMin) inputMin.textContent = minDefault;
                        if (inputMax) inputMax.textContent = maxDefault;

                        if (progress) {
                            progress.style.left = '0%';
                            progress.style.right = '0%';
                        }

                        // Update selected filters and trigger AJAX
                        updateSelectedFilters();

                        setTimeout(() => {
                            if (typeof updateCollectionResults === 'function') {
                                updateCollectionResults();
                            }
                        }, 50);
                    }
                });

                selectedFiltersContainer.appendChild(priceFilterTag);
            }
        }

        // Get all checked inputs
        const checkedInputs = document.querySelectorAll('.custom-filter-wrapper input[type="checkbox"]:checked');

        checkedInputs.forEach(input => {
            // Skip if already has a server-rendered tag
            const existingTag = selectedFiltersContainer.querySelector(`[data-filter-param="${input.name}"][data-filter-value="${input.value}"]`);
            if (existingTag && !existingTag.classList.contains('dynamic')) return;

            // Get filter label from the closest filter container
            const filterContainer = input.closest('.custom-filter');
            let filterLabel = 'Filter';
            let filterValueLabel = input.value;

            if (filterContainer) {
                const filterHeading = filterContainer.querySelector('.filter-heading');
                if (filterHeading) {
                    filterLabel = filterHeading.textContent.trim();
                }

                // Get the actual label text from the input's label
                const inputLabel = input.closest('label');
                if (inputLabel) {
                    const labelText = inputLabel.textContent.trim();
                    // Remove the count in parentheses if present
                    filterValueLabel = labelText.replace(/\s*\(\d+\)\s*$/, '').trim();
                }
            }

            // Handle special cases for custom image filters
            if (input.classList.contains('lifestage-filter-input')) {
                filterLabel = 'Lifestage';
                filterValueLabel = input.value;
            } else if (input.classList.contains('product-type-filter-input')) {
                filterLabel = 'Product Type';
                filterValueLabel = input.value;
            }

            // Create new filter tag
            const filterTag = document.createElement('a');
            filterTag.className = 'selected-filter dynamic';
            filterTag.setAttribute('href', '#');
            filterTag.setAttribute('aria-label', 'Remove Filter');
            filterTag.setAttribute('data-filter-type', 'list');
            filterTag.setAttribute('data-filter-param', input.name);
            filterTag.setAttribute('data-filter-value', input.value);

            // Add close icon (you might need to adjust this based on your icon system)
            filterTag.innerHTML = `
                <svg width="10" height="10" viewBox="0 0 10 10">
                    <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
                </svg>
                ${filterValueLabel}
            `;

            // Add click handler to remove filter
            filterTag.addEventListener('click', function(e) {
                e.preventDefault();
                input.checked = false;

                // Dispatch both change and click events to ensure all systems pick it up
                input.dispatchEvent(new Event('change', { bubbles: true }));
                input.dispatchEvent(new Event('click', { bubbles: true }));

                // Update active states for special filter types
                if (input.classList.contains('lifestage-filter-input')) {
                    updateLifestageActiveStates();
                } else if (input.classList.contains('product-type-filter-input')) {
                    updateProductTypeActiveStates();
                }

                // Close mobile filter overlay if open
                const mobileControl = document.querySelector('.mobile-filter-heading');
                const filterBody = document.querySelector('.custom-filter-wrapper');
                const promoBar = document.querySelector('.promotional-bar');
                const announcementBar = document.querySelector('.announcement-bar');

                if (mobileControl && mobileControl.classList.contains('open')) {
                    mobileControl.classList.remove('open');
                }
                if (filterBody && filterBody.classList.contains('open')) {
                    filterBody.classList.remove('open');
                }
                if (promoBar && promoBar.classList.contains('open')) {
                    promoBar.classList.remove('open');
                }
                if (announcementBar && announcementBar.classList.contains('open')) {
                    announcementBar.classList.remove('open');
                }

                // Force AJAX update with a small delay to ensure state is updated
                setTimeout(() => {
                    if (typeof updateCollectionResults === 'function') {
                        updateCollectionResults();
                    }
                }, 50);
            });

            selectedFiltersContainer.appendChild(filterTag);
        });
    }

    // Handle clicks on existing selected filter tags
    document.addEventListener('click', function(e) {
        if (e.target.closest('.selected-filter')) {
            const filterTag = e.target.closest('.selected-filter');

            // If it's a dynamic filter tag, handle with JavaScript
            if (filterTag.classList.contains('dynamic')) {
                e.preventDefault();
                const filterParam = filterTag.getAttribute('data-filter-param');
                const filterValue = filterTag.getAttribute('data-filter-value');

                // Find and uncheck the corresponding input
                const input = document.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);
                if (input) {
                    input.checked = false;

                    // Dispatch both change and click events to ensure all systems pick it up
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                    input.dispatchEvent(new Event('click', { bubbles: true }));

                    // Match the same behavior as when filter elements are clicked
                    // Update active states for special filter types
                    if (input.classList.contains('lifestage-filter-input')) {
                        updateLifestageActiveStates();
                    } else if (input.classList.contains('product-type-filter-input')) {
                        updateProductTypeActiveStates();
                    }

                    // Close mobile filter overlay if open
                    const mobileControl = document.querySelector('.mobile-filter-heading');
                    const filterBody = document.querySelector('.custom-filter-wrapper');
                    const promoBar = document.querySelector('.promotional-bar');
                    const announcementBar = document.querySelector('.announcement-bar');

                    if (mobileControl && mobileControl.classList.contains('open')) {
                        mobileControl.classList.remove('open');
                    }
                    if (filterBody && filterBody.classList.contains('open')) {
                        filterBody.classList.remove('open');
                    }
                    if (promoBar && promoBar.classList.contains('open')) {
                        promoBar.classList.remove('open');
                    }
                    if (announcementBar && announcementBar.classList.contains('open')) {
                        announcementBar.classList.remove('open');
                    }

                    // Force AJAX update with a small delay to ensure state is updated
                    setTimeout(() => {
                        if (typeof updateCollectionResults === 'function') {
                            updateCollectionResults();
                        }
                    }, 50);
                }
            }
            // Otherwise, let the server-side href handle it (fallback for non-JS users)
        }
    });

    // Initialize selected filters on page load
    updateSelectedFilters();

    // Debug: log price filter input values on page load
    console.log('min-price-filter value:', document.querySelector('.min-price-filter')?.value);
    console.log('max-price-filter value:', document.querySelector('.max-price-filter')?.value);
});